import { useEffect } from 'react';
import { init, reactRouterV6BrowserTracingIntegration } from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { DEVELOP_MODE } from '@/common/constants/common';

const devMode = process.env.BUILD_MODE === DEVELOP_MODE;

if (!devMode) {
  init({
    dsn: 'https://8d8b006cbfa25b6566da3e07e87a483f@o4507096952668160.ingest.de.sentry.io/4507526091178064',
    environment: 'production',
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
  });
}
